import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';

import Button from '../Button/Button';
import { FaPhone } from 'react-icons/fa';

import './CallUsButton.css';

const CallUsButton = ({ children, fixedWidth, phoneNumber }) => {
  const [showModal, setShowModal] = useState(false);

  const formatToInternational = (rawNumber) => {
    // Remove everything that's not a digit
    const digits = rawNumber.replace(/\D/g, '');
    // Ensure the number starts with country code "1"
    const formatted = digits.startsWith('1') ? `+${digits}` : `+1${digits}`;
    return formatted;
  };
  const callNumber = formatToInternational(phoneNumber);

  const stripCountryCode = (rawNumber) => {
    // Remove all non-digit characters first
    const digits = rawNumber.replace(/\D/g, '');
    // If the number starts with '1' and has 11 digits, remove the leading '1'
    const localNumber =
      digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

    //   Format as ddd-ddd-dddd
    return localNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  };
  const displayNumber = stripCountryCode(phoneNumber);

  const handleCallclick = () => {
    if (isMobile) {
      // Mobile device - make a call
      window.location.href = `tel:${callNumber}`;
    } else {
      // Desktop - show the number in a modal
      setShowModal(true);
    }
  };

  return (
    <>
      <Button fixedWidth={fixedWidth} onClick={handleCallclick}>
        {children}
      </Button>

      {showModal && (
        <div className='call-modal' onClick={() => setShowModal(false)}>
          <div
            className='call-modal-content'
            onClick={(e) => e.stopPropagation()}
          >
            <p>
              <FaPhone className='flip-horizontal' />
              Call us at <span className='line-break-small'></span>
              {displayNumber}
            </p>
            <div className='close-btn-container'>
              <Button
                size='xsmall'
                fixedWidth={false}
                onClick={() => {
                  setShowModal(false);
                }}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CallUsButton;
